import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';

import { DashboardComponent } from './dashboard/dashboard.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TableListComponent } from './table-list/table-list.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { AgmCoreModule } from '@agm/core';

import {MatButtonModule} from '@angular/material/button';

import {MatButtonToggleModule} from '@angular/material/button-toggle';

import {MatInputModule} from '@angular/material/input';
import {MatRippleModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
import {MatDialogModule} from '@angular/material/dialog';
import {MatStepperModule} from '@angular/material/stepper';
import {MatRadioModule} from '@angular/material/radio';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';


import {MatExpansionModule} from '@angular/material/expansion';
import {CdkAccordionModule} from '@angular/cdk/accordion';

import {CdkTableModule} from '@angular/cdk/table';

import {DragDropModule} from '@angular/cdk/drag-drop';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthentificationComponent } from './authentification/authentification.component';
import { DeliverymanagerComponent } from './deliverymanager/deliverymanager.component';
import { CommandesComponent } from './commandes/commandes.component';
import { LivraisonComponent } from './livraison/livraison.component';
import { PartenairesComponent } from './partenaires/partenaires.component';
import { DetailcommandeComponent } from './detailcommande/detailcommande.component';

import { Deliverymodale } from './livraison/livraison.component';
import { SavComponent } from './sav/sav.component';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ParametrageComponent } from './parametrage/parametrage.component';
import { PrimeconfigComponent } from './primeconfig/primeconfig.component';
import { TypedefdialogComponent } from './typedefdialog/typedefdialog.component';
import { FormulemakerComponent } from './formulemaker/formulemaker.component';
import { VehiculeparamComponent } from './vehiculeparam/vehiculeparam.component';
import { FormulasComponent } from './formulas/formulas.component';
import { SelectedAssuranceComponent } from './selected-assurance/selected-assurance.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { RecurrentComponent } from './recurrent/recurrent.component';
import { CustomParameterComponent } from './custom-parameter/custom-parameter.component';
import { PredefparamchooseComponent } from './predefparamchoose/predefparamchoose.component';
import { ConfirmsouscriptionComponent } from './confirmsouscription/confirmsouscription.component';
import { UsrcreationComponent } from './usrcreation/usrcreation.component';
import { AddtypeinsuranceComponent } from './addtypeinsurance/addtypeinsurance.component';
import { AddbigcategComponent } from './addbigcateg/addbigcateg.component';
import { AddgarantieComponent } from './addgarantie/addgarantie.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { TooltipDirective } from './tooltip.directive';
import { ConstantesComponent } from './constantes/constantes.component';

import { DetailsComponent } from './details/details.component';
import { DetailopsComponent } from './detailops/detailops.component';
import { PackagingComponent } from './packaging/packaging.component';
import { PackageComponent } from './package/package.component';
import { PackagepublicComponent } from './packagepublic/packagepublic.component';
import { ComptafinancesComponent } from './comptafinances/comptafinances.component';
import { FraischargeComponent } from './fraischarge/fraischarge.component';
import { KhandalguiComponent } from './khandalgui/khandalgui.component';

import { ConfigfraisparamsComponent } from './configfraisparams/configfraisparams.component';
import { AvenantsComponent } from './avenants/avenants.component';

import { AvenantblockComponent } from './avenantblock/avenantblock.component';

import { ImpressionTPVComponent } from './impression-tpv/impression-tpv.component';
import { PaymantmodalComponent } from './paymantmodal/paymantmodal.component';
import { RapportFinComponent } from './rapport-fin/rapport-fin.component';
import { FinReportingComponent } from './fin-reporting/fin-reporting.component';
import { PrintpropositionComponent } from './printproposition/printproposition.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { ReimpressionTpvComponent } from './reimpression-tpv/reimpression-tpv.component';



@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatDialogModule,
    MatStepperModule,
    MatRadioModule,
    MatChipsModule,
    MatIconModule,
    MatListModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatNativeDateModule,
    HttpClientModule,
    ComponentsModule,
    PdfViewerModule,
    DragDropModule,
    RouterModule,

    MatExpansionModule,
    CdkAccordionModule,
    CdkTableModule,

    AppRoutingModule,
    AgmCoreModule.forRoot({
      apiKey: 'YOUR_GOOGLE_MAPS_API_KEY'
    }),
  ],

  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AuthentificationComponent,
    DetailcommandeComponent,
    Deliverymodale,
    SavComponent,
    ParametrageComponent,
    PrimeconfigComponent,
    TypedefdialogComponent,
    FormulemakerComponent,
    VehiculeparamComponent,
    FormulasComponent,
    SelectedAssuranceComponent,
    ConfirmationDialogComponent,
    RecurrentComponent,
    CustomParameterComponent,
    PredefparamchooseComponent,
    ConfirmsouscriptionComponent,
    UsrcreationComponent,
    AddtypeinsuranceComponent,
    AddbigcategComponent,
    AddgarantieComponent,
    TooltipComponent,
    TooltipDirective,
    ConstantesComponent,
    DetailopsComponent,
    DetailsComponent,
    PackagingComponent,
    PackageComponent,
    PackagepublicComponent,
    ComptafinancesComponent,
    FraischargeComponent,
    KhandalguiComponent,
    ConfigfraisparamsComponent,
    AvenantsComponent,
    AvenantblockComponent,
    ImpressionTPVComponent,
    PaymantmodalComponent,
    PrintpropositionComponent,
    InvoiceComponent,
    ReimpressionTpvComponent,
    // FinReportingComponent,
    // RapportFinComponent
  ],

  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule { 


}
